import {
  RECEIVE_BACK_IN_STOCK_VARIANTS,
  UPDATE_BACK_IN_STOCK_VARIANTS
} from "../constants";
import {
  receiveBackInStockVariants,
  updateBackInStockVariants
} from "./payloadCreators";

export default {
  [RECEIVE_BACK_IN_STOCK_VARIANTS]: receiveBackInStockVariants,
  [UPDATE_BACK_IN_STOCK_VARIANTS]: updateBackInStockVariants
};
